import React, { useCallback, useState } from "react";

import type { Graphics as GraphicsType } from "pixi.js";
import { Container, Graphics, Texture } from "pixi.js";
import { extend } from "@pixi/react";

// import { IPixPolygon } from "../types";
// import { getCenterOfPolygon, getPolygonDimension } from "../utils/geo";

extend({ Container });
extend({ Graphics });

interface PixBimRectangleProps {
  fill: string;
  width: number;
  height: number;
  point: number[];
}

const PixBimRectangle: React.FC<PixBimRectangleProps> = ({
  fill = "#000000",
  width,
  height,
  point,
}) => {
  const [fillColor] = useState(fill);
  const [strokeColor] = useState("#000000");

  const [x, y] = point;
  const strokeWidth = 1;
  const draw = useCallback(
    (g: GraphicsType) => {
      const texture: Texture = Texture.WHITE;
      texture.source.scaleMode = "nearest";
      g.clear();
      g.fill({ texture, color: fillColor });
      g.rect(x, y, width, height);

      g.eventMode = "static";
      g.stroke({ color: strokeColor, width: strokeWidth, texture });
      g.fill();
    },
    [x, y, width, height, strokeColor, fillColor, strokeWidth]
  );

  return (
    <container>
      <graphics draw={draw} />
    </container>
  );
};

export default PixBimRectangle;
